<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
      class="pa-5"
    >

      <profile-form
        :profile="profile"
        :update="update"
      ></profile-form>

      <profile-preview :profile="profile"></profile-preview>

    </v-layout>

    <!-- Snackbar -->
    <v-snackbar
      right
      multi-line
      :color="snackbarColor"
      v-model="snackbar"
    >
      <b>
        <span>{{message}}</span>
      </b>
      <v-btn
        text
        @click="snackbar = false"
      >
        Chiudi
      </v-btn>
    </v-snackbar><!-- /Snackbar -->
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  import ProfileForm from './../components/profile/ProfileForm'
  import ProfilePreview from './../components/profile/ProfilePreview'

  export default {
    name: 'Profilo',
    components: {
      ProfileForm,
      ProfilePreview
    },
    data() {
      return {
        profile: {
          title: null,
          avatar: null,
          website: null,
          linkedin: null,
          facebook: null,
          instagram: null,
          bio: null
        },
        errors: false,
        snackbar: false,
        message: null
      }
    },
    methods: {
      update() {
        if (this.profile.bio && this.profile.bio.length > 512) {
          this.errors = true
          this.message = 'Testo della bio troppo lungo...'

        } else {
          this.$store.dispatch('updateProfile', this.profile)
            .then(result => {
              if (result.status === 200) {
                this.errors = false
                this.message = 'Profilo aggiornato!'
                this.profile = { ...result.data.profile }
              } else {
                this.errors = true
                this.message = 'Aggiornamento profilo fallito...'
              }
            })
        }

        this.snackbar = true
      }
    },
    computed: {
      ...mapGetters([
        'getProfile'
      ]),
      snackbarColor() {
        return this.errors ? 'pink' : 'primary'
      }
    },
    created() {
      this.$store.dispatch('fetchProfile')
        .then(profile => {

          this.profile = { ...profile.data }
        })
    }
  }
</script>

<style scoped>
</style>
